<template>
<div>
    

    <v-card
        v-for="(group, index) in profile.organization_account.groups"
        :key="index"
        style="margin-bottom: 15px"
    >
        <v-card-title>{{group.label}}</v-card-title>
        <v-card-text>

            <m-edit-text
                label="Label"
                :value="group.label"
                :read_only="read_only"
                v-on:input="setLabel(group, $event)"
            />

            <m-edit-chip
                label="RedChirp User"
                dialog_title="RedChirp users in this group"
                :value="createTeamMemberChips(group)"
                :possible_values="createPossibleTeamMemberChips(group)"
                :read_only="read_only"
                v-on:input="setEmployees(group, $event)"
            />

            <div
                v-if="hasTeamUses(group)"
            >
                <div class="label">
                    This team is being used:
                </div>
                <v-list
                    style="margin-bottom: 15px"
                    dense
                >
                    <v-list-item
                        v-for="(group_use, use_idx) in getTeamUses(group)"
                        :key="use_idx"
                    >
                        {{ group_use }}
                    </v-list-item>
                </v-list>
            </div>
        </v-card-text>


        <div
            style="position: absolute; right: 20px; top: 20px;"
        >
            <v-menu 
                bottom 
                offset-y  
            >
                <template v-slot:activator="{ on }">
                    
                    <v-icon
                        v-on="on"
                        color="primary"
                    >
                        mdi-dots-vertical
                    </v-icon>
                    
                </template>

                <v-list>
                    <v-list-item
                        :disabled="index == 0"
                        v-on:click="moveGroup(group,true)"
                    >
                        <v-list-item-title>Move Up</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        :disabled="index == profile.organization_account.groups.length-1"
                        v-on:click="moveGroup(group,false)"
                    >
                        <v-list-item-title>Move Down</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="deleteGroup(group)"
                    >
                        <v-list-item-title>Delete...</v-list-item-title>
                    </v-list-item>

                </v-list>

            </v-menu>


        </div>
    </v-card>

    <v-row>
    <v-col>
    </v-col>

    <v-col
        class='flex-grow-0'
    >
        <v-btn 
            class="mx-2" fab dark small color="primary"
            v-on:click="addGroup()"
        >
            <v-icon dark>mdi-plus</v-icon>
        </v-btn>
    </v-col>
    </v-row>
</div>
</template>

<script>
const _ = require('lodash');
const { v4: uuidv4 } = require('uuid');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    data() {
        return {
            group_uses: {},
        }
    },

    beforeDestroy () {
        this.$event_bus.$off('common-update-organization', this.loadGroupUsesAsync);
        this.$event_bus.$off('common-update-redchirp-phone-numbers', this.loadGroupUsesAsync);

    },

    created() {
        this.$event_bus.$on('common-update-organization', this.loadGroupUsesAsync);
        this.$event_bus.$on('common-update-redchirp-phone-numbers', this.loadGroupUsesAsync);
    },

    mounted() {
        this.loadGroupUsesAsync();
    },

    methods: {
        loadGroupUsesAsync(signal) {
            // if different account, don't reload
            if (signal && signal.organization_id != this.profile.organization_id) return;

            for (let i=0; i < this.profile.organization_account.groups.length; i++)
            {
                let group = this.profile.organization_account.groups[i];

                this.$rc.listEmployeeGroupUses(
                    group.organization_id,
                    group.employee_group_id,
                    (data) => {
                        this.group_uses[group.employee_group_id] = data.results;
                        this.$forceUpdate();
                    },
                    () => {
                        this.group_uses[group.employee_group_id] = null;
                    }
                );
            }
        },

        createTeamMemberChips(group) {
           let all_employees =  this.createAllTeamMemberChips();  

           let ret = [];

           for ( let i = 0; i < all_employees.length; i++ )
           {
               if ( !this.employeeInGroup(all_employees[i].employee_id, group) ) continue;
               ret.push(all_employees[i]);
           }

           return ret;
        },

        employeeInGroup(employee_id, group)
        {
            for ( let i = 0; i < group.employee_ids.length; i++ )
            {
                if ( group.employee_ids[i] == employee_id ) 
                    return true;
            }

            return false;
        },

        createAllTeamMemberChips(group) {
            let ret = [];
            
            for ( let i = 0; i < this.profile.employees.length; i++ )
            {
                let employee = this.profile.employees[i];

                ret.push({
                    'text' : employee.label,
                    'employee_id' : employee.employee_id,
                });
            }

            return ret;
        },

        createPossibleTeamMemberChips(group)
        {
            let ret = [];
            
            for ( let i = 0; i < this.profile.employees.length; i++ )
            {
                let employee = this.profile.employees[i];

                if ( employee.is_archived ) continue;

                ret.push({
                    'text' : employee.label,
                    'employee_id' : employee.employee_id,
                });
            }

            return ret;
        },

        setLabel(orig_group, new_label)
        {
            let group = _.cloneDeep(orig_group);
            group.label = new_label;

            this.$emit('post-group',group);
        },

        setEmployees(orig_group, new_employees)
        {
            let group = _.cloneDeep(orig_group);
            
            group.employee_ids = [];

            for ( let i = 0; i < new_employees.length; i++ )
            {
                group.employee_ids.push(new_employees[i].employee_id);
            }

            this.$emit('post-group',group);
        },

        addGroup()
        {
            let group = {
                'organization_id' : this.profile.organization_account.organization_id,
                'employee_group_id' : uuidv4(),
                'label' : 'New Group',
                'employee_ids' : [],
            };

            this.$emit('post-group',group);
        },

        deleteGroup(group)
        {
            if ( this.hasTeamUses(group) )
            {
                this.$rc.alert(
                    "This Team Cannot be Deleted",
                    "This team can't be deleted because it's being used right now. " +
                    "To delete this team, remove it from all use cases and try again."
                );

                return;
            }

            if ( !confirm('Permanently delete this group?') )
                return;

            this.$emit('delete-group',group);
        },

        moveGroup(group, is_up)
        {
            let move_obj = {
                'organization_id': group.organization_id,
                'employee_group_id': group.employee_group_id,
                'direction': is_up ? 'up' : 'down',
            };

            this.$emit('move-group',move_obj);
        },

        hasTeamUses(group)
        {
            if (this.group_uses[group.employee_group_id] != null && this.group_uses[group.employee_group_id].length > 0)
            {
                return true;
            }

            return false;
        },

        getTeamUses(group)
        {
            return this.group_uses[group.employee_group_id];
        },
    },

    computed: {
        read_only() {
            return !this.profile.actor_permissions.can_write; 
        },
    },
}
</script>

<style lang="scss" scoped>

</style>